import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgVanityArea = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 22,
  height: 22,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 21v1H0v-1h22ZM17 0a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12Zm0 1H5a1 1 0 0 0-.993.883L4 2v16a1 1 0 0 0 .883.993L5 19h12a1 1 0 0 0 .993-.883L18 18V2a1 1 0 0 0-.883-.993L17 1Zm-1 1a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10Zm0 1H6v14h10V3Zm-2.5 4.793.707.707L8.5 14.207l-.707-.707L13.5 7.793Zm-1-2 .707.707L8.5 11.207l-.707-.707L12.5 5.793Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgVanityArea;